import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { MasterService } from '../../../services/master.service';
import { StoreService } from '../../../services/store.service';
import * as words from '../../../services/language'
import { AutomationEntry } from 'src/app/models/automation-entry.model';
import { Subscription } from 'rxjs';


@Component({
    selector: 'stats-automation',
    templateUrl: './stats-automation.component.html',
    styleUrls: ['./stats-automation.component.scss'],
    standalone: false
})
export class StatsAutomationComponent implements OnInit, OnChanges, OnDestroy {
    
    // Currently selected language
    @Input() language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    // Word replacements for each language.
    @Input() words: Object = words.language

    /** The currently selected lot on the navbar. */
    private lotId: number = 0;

    // A list of user favorites.
    protected entry: AutomationEntry | null = null

    /** Listen for navbar events and make decisions. */
    private navbarWatcher: Subscription | null = null
    
    // Indicates whether the data is currently loading.
    protected loading: boolean = false

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService) { }

    ngOnInit() {
        this.lotId = parseInt(localStorage.getItem('lot') || this.store.lotSelected)

        this.navbarWatcher = this.ms.channelComponents$.subscribe(res => {
            switch (res.message) {
                case "changeLanguage":
                    this.language = res.value
                    break
                case 'changeLot':
                    this.lotId = parseInt(res.value.lot)
                    this.reset()
                    this.fetch()
                    break
            }
        })

        this.reset()
        this.fetch()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }
    }

    ngOnDestroy(): void {
        if (this.navbarWatcher) {
            this.navbarWatcher.unsubscribe()
            this.navbarWatcher = null
        }
    }

    /*
    * Reset the favorites array
    */
    private reset = (): void => {
        this.entry = null
    }

    /**
     * 
     */
    private fetch() {
        if (this.loading) {
            return
        }

        if (!this.lotId || (this.lotId <= 0)) {
            return
        }

        this.entry = null

        this.loading = true
        this.master.get(`automations?pi=1&ipp=1&jobType=computeStats&lotId=${this.lotId}`, (res) => {
            this.loading = false

            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }
  
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            if (!res.data || !res.data.entries || (res.data.entries.length <= 0)) {
                return
            }

            this.entry = res.data.entries[0]
        })
    }

    protected badgeClass = (status: string): string => {
        if (!status) {
            return 'badge badge-pending'
        }

        switch (status.toLocaleLowerCase()) {
            case 'running':
                return 'badge badge-pending'
            case 'success':
                return 'badge badge-success'
            case 'failure':
                return 'badge badge-danger'
            default:
                return 'badge badge-secondary'
        }
    }
}
